const moduleNameKey = "staticHeader";

export const staticHeaderEn = {
  [moduleNameKey]: {
    contentLabel: "Content",
    contentPlaceholder: "Enter text",
    fontSizeLabel: "Font size",
    alignmentLabel: "Alignment",
    alignmentLeft: "Left",
    alignmentCenter: "Center",
    alignmentRight: "Right",
    fontColorLabel: "Font color",
    transparentLabel: "Transparent background",
    saveButton: "Save",
    cancelButton: "Cancel",
  },
};

export const staticHeaderPtBr = {
  [moduleNameKey]: {
    contentLabel: "Conteúdo",
    contentPlaceholder: "Digite o texto",
    fontSizeLabel: "Tamanho da fonte",
    alignmentLabel: "Alinhamento",
    alignmentLeft: "Esquerda",
    alignmentCenter: "Centro",
    alignmentRight: "Direita",
    fontColorLabel: "Cor da fonte",
    transparentLabel: "Fundo transparente",
    saveButton: "Salvar",
    cancelButton: "Cancelar",
  },
};

export const staticHeaderDe = {
  [moduleNameKey]: {
    contentLabel: "Inhalt",
    contentPlaceholder: "Text eingeben",
    fontSizeLabel: "Schriftgröße",
    alignmentLabel: "Ausrichtung",
    alignmentLeft: "Links",
    alignmentCenter: "Mitte",
    alignmentRight: "Rechts",
    fontColorLabel: "Schriftfarbe",
    transparentLabel: "Transparenter Hintergrund",
    saveButton: "Speichern",
    cancelButton: "Abbrechen",
  },
};

export const staticHeaderZhHans = {
  [moduleNameKey]: {
    contentLabel: "内容",
    contentPlaceholder: "输入文本",
    fontSizeLabel: "字体大小",
    alignmentLabel: "对齐",
    alignmentLeft: "左",
    alignmentCenter: "居中",
    alignmentRight: "右",
    fontColorLabel: "字体颜色",
    transparentLabel: "透明背景",
    saveButton: "保存",
    cancelButton: "取消",
  },
};

export const staticHeaderIt = {
  [moduleNameKey]: {
    contentLabel: "Contenuto",
    contentPlaceholder: "Inserisci testo",
    fontSizeLabel: "Dimensione testo",
    alignmentLabel: "Allineamento",
    alignmentLeft: "Sinistra",
    alignmentCenter: "Centro",
    alignmentRight: "Destra",
    fontColorLabel: "Colore testo",
    transparentLabel: "Sfondo trasparente",
    saveButton: "Salva",
    cancelButton: "Annulla",
  },
};

export const staticHeaderEs = {
  [moduleNameKey]: {
    contentLabel: "Contenido",
    contentPlaceholder: "Ingrese texto",
    fontSizeLabel: "Tamaño de fuente",
    alignmentLabel: "Alineación",
    alignmentLeft: "Izquierda",
    alignmentCenter: "Centro",
    alignmentRight: "Derecha",
    fontColorLabel: "Color de fuente",
    transparentLabel: "Fondo transparente",
    saveButton: "Guardar",
    cancelButton: "Cancelar",
  },
};

export const staticHeaderNl = {
  [moduleNameKey]: {
    contentLabel: "Inhoud",
    contentPlaceholder: "Typ tekst",
    fontSizeLabel: "Lettergrootte",
    alignmentLabel: "Uitlijning",
    alignmentLeft: "Links",
    alignmentCenter: "Midden",
    alignmentRight: "Rechts",
    fontColorLabel: "Letterkleur",
    transparentLabel: "Transparante achtergrond",
    saveButton: "Opslaan",
    cancelButton: "Annuleren",
  },
};

export const staticHeaderTr = {
  [moduleNameKey]: {
    contentLabel: "İçerik",
    contentPlaceholder: "Metin girin",
    fontSizeLabel: "Yazı tipi boyutu",
    alignmentLabel: "Hizalama",
    alignmentLeft: "Sol",
    alignmentCenter: "Orta",
    alignmentRight: "Sağ",
    fontColorLabel: "Yazı tipi rengi",
    transparentLabel: "Şeffaf arka plan",
    saveButton: "Kaydetmek",
    cancelButton: "İptal etmek",
  },
};
